import { Breakpoints } from '@zocdoc/components/src/grid';

// TODO: Deprecate in favor of withMobileViewport
export default function isMobileBreakpoint() {
    return typeof window !== 'undefined' && window.innerWidth < Breakpoints.small;
}

export function isTabletOrMobileBreakpoint() {
    return typeof window !== 'undefined' && window.innerWidth < Breakpoints.medium;
}

export function isTabletBreakpoint() {
    return isTabletOrMobileBreakpoint() && !isMobileBreakpoint();
}
